import { useNavigate, useParams } from "react-router";

import {
  Button,
  Card,
  Heading,
  Link,
  MarketingIcon,
  Span
} from "@icg360/design-system";

import styles from "./LiftLockSuccess.module.css";

export const LiftLockSuccess = () => {
  const navigate = useNavigate();
  const params = useParams();

  return (
    <div className={styles.container}>
      <Card className={styles.successCard}>
        <div className={styles.icon}>
          <MarketingIcon name="CheckMark" size="lg" />
        </div>
        <Heading size="lg">Your order has been received</Heading>
        <Heading size="md">Here is what happens next:</Heading>
        <div className={styles.infoLine}>
          <div className={styles.icon}>
            <MarketingIcon name="ESignature" size="sm" />
          </div>
          LiftLock LLC will send a service agreement for you to sign
        </div>
        <div className={styles.infoLine}>
          <div className={styles.icon}>
            <MarketingIcon name="Megaphone" size="sm" />
          </div>
          Your insurance rep will finalize your policy
        </div>
        <div className={styles.infoLine}>
          <div className={styles.icon}>
            <MarketingIcon name="UnderwritingReview" size="sm" />
          </div>
          Your property will be inspected
        </div>
        <div className={styles.infoLine}>
          <div className={styles.icon}>
            <MarketingIcon name="Email" size="sm" />
          </div>
          LiftLock LLC will make an appointment to reseal your shingles
        </div>
        <Span>
          If you have any questions, please reach out to{" "}
          <Link href="mailto:support@liftlockhome.com">
            support@liftlockhome.com
          </Link>
        </Span>
        <div className={styles.buttons}>
          <Button onClick={() => void navigate(`/${params.proposal}`)}>
            Back to SageSure quote
          </Button>
          <Button appearance="tertiary">
            <a
              href="https://www.LiftLockHome.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn more about LiftLock LLC
            </a>
          </Button>
        </div>
      </Card>
    </div>
  );
};
